<template>
    <div>
        <v-data-table :headers="headers"
                      :items="items"
                      :items-per-page="2"
                      class="elevation-1">
            <template v-slot:[`item.delete`]="{ item }">
                <v-btn @click="deleteRow(item.id)">Delete</v-btn>
            </template>
        </v-data-table>
        <v-btn @click="newRedirectUri">New Redirect Uri</v-btn>
        <v-dialog v-model="newClientRedirectDialogVisible" max-width="500px">
            <v-form ref="newClientRedirectDialogForm">
                <v-card>
                    <v-card-title>
                        <span class="headline">New Client Redirect Uri</span>
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="newClientRedirectUri" label="Client Redirect Uri" :rules="clientRedirectUriRules" required :counter=2000 />
                    </v-card-text>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="quaternary" text @click="cancel">Cancel</v-btn>
                        <v-btn color="quaternary" text @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import errorUtility from '../../services/errorUtility'
    export default {
        props: [
            'clientId',
        ],
        data() {
            return {
                headers: [
                    {
                        text: 'Redirect Uri',
                        align: 'start',
                        sortable: false,
                        value: 'redirectUrl',
                    },
                    { text: 'Delete', value: 'delete' },
                ],
                items: [],
                newClientRedirectDialogVisible: false,
                isSaving: false,
                clientRedirectUriRules: [v => !!v || 'Website Url is required', v => !(v && v.length > 2000) || 'Website Url must be less than 2000 characters'], isRequired: true,
                newClientRedirectUri: ""
            }
        },
        methods: {
            newRedirectUri() {
                this.newClientRedirectDialogVisible = true;
            },
            cancel() {
                this.close();
            },
            close() {
                this.newClientRedirectDialogVisible = false;
                this.newClientRedirectUri = "";
            },
            async save() {
                if (this.isSaving) { return; }
                if (!this.$refs.newClientRedirectDialogForm.validate()) { return; }
                this.isSaving = true;
                try {
                    var item = {
                        OauthClientId: this.clientId,
                        RedirectUrl: this.newClientRedirectUri
                    };
                    await axios.post('/api/OauthClientRedirectUris/', item);
                    await this.load();
                    this.close();
                } catch (error) {
                    this.$emit('open');
                    errorUtility.handleServerError(error);
                }
                finally {
                    this.isSaving = false;
                }
            },
            async load() {
                let params = {
                    clientId: this.clientId
                }
                let response = await axios.get('/api/OauthClientRedirectUris/', { params });
                this.items = response.data.items;
            },
            async deleteRow(itemId) {
                if (confirm("Are you sure you want to delete this item?")) {
                    try {
                        await axios.delete(`/api/OauthClientRedirectUris/${itemId}`);
                        await this.load();
                    } catch (error) {
                        this.$emit('open');
                        errorUtility.handleServerError(error);
                    }
                    finally {
                        this.isSaving = false;
                    }
                }
            }
        },
        async mounted() {
            await this.load();
        },
    };
</script>
